import React from "react";
import { Box, Container, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { retrieveKidsBooks } from "./selector";
import { Product } from "../../../lib/types/product";
import { serverApi } from "../../../lib/config";
import { useHistory } from "react-router-dom";

const kidsBooksRetriever = createSelector(retrieveKidsBooks, (kidsBooks) => ({
  kidsBooks,
}));

export default function Children() {
  const history = useHistory();
  const { kidsBooks } = useSelector(kidsBooksRetriever);
  const featuredKidBook = kidsBooks[0];
  const kidPicks = kidsBooks.slice(1, 5);

  const chooseBookHandler = (id: string) => {
    history.push(`/products/${id}`);
  };

  const getImagePath = (product: Product) =>
    product.productImages?.[0] ? `${serverApi}/${product.productImages[0]}` : "";

  const hideBrokenImage = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <div className={"popular-children-frame"}>
      <Container>
        <Stack className={"popular-section"}>
          <Stack className={"section-heading compact"}>
            <span className={"section-kicker"}>For young readers</span>
            <Box className={"category-title"}>Kids Bestsellers</Box>
          </Stack>

          {featuredKidBook ? (
            <div className={"kids-showcase"}>
              <article
                className={"kids-hero-card"}
                onClick={() => chooseBookHandler(featuredKidBook._id)}
              >
                <span className={"kids-shape one"} />
                <span className={"kids-shape two"} />
                <span className={"kids-shape three"} />

                <div className={"kids-hero-copy"}>
                  <span>Kids corner</span>
                  <h3>Build a tiny library for big imaginations.</h3>
                  <p>
                    Playful stories, bright covers and simple picks for young
                    readers.
                  </p>
                  <button type="button">Explore kids books</button>
                </div>

                <div className={"kids-feature-book"}>
                  <div className={"kids-feature-cover"}>
                    {getImagePath(featuredKidBook) && (
                      <img
                        src={getImagePath(featuredKidBook)}
                        alt=""
                        onError={hideBrokenImage}
                      />
                    )}
                  </div>
                  <strong>{featuredKidBook.productName}</strong>
                  <small>{featuredKidBook.productAuthor}</small>
                </div>
              </article>

              <div className={"kids-picks"}>
                {kidPicks.map((product: Product, index: number) => (
                  <article
                    className={"kids-pick-card"}
                    key={product._id}
                    onClick={() => chooseBookHandler(product._id)}
                  >
                    <div className={"kids-pick-cover"}>
                      {getImagePath(product) && (
                        <img
                          src={getImagePath(product)}
                          alt=""
                          onError={hideBrokenImage}
                        />
                      )}
                      <span>{index + 1}</span>
                    </div>

                    <div className={"kids-pick-copy"}>
                      <h4>{product.productName}</h4>
                      <p>{product.productAuthor}</p>
                    </div>

                    <strong>${product.productPrice}</strong>
                  </article>
                ))}
              </div>
            </div>
            ) : (
            <Box className="no-data">Kids books are not available yet.</Box>
          )}
        </Stack>
      </Container>
    </div>
  );
}
